import React from 'react';
import styled from 'styled-components';
import SimpleNav from './SimpleNav';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
  headerBackground?: string;
}

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--gray-50);
`;

const Main = styled.main<{ $isHomePage: boolean }>`
  flex: 1;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: ${props => props.$isHomePage ? '0' : 'var(--space-8) var(--space-4)'};
  animation: fadeIn 0.5s ease-out;
  
  @media (max-width: 768px) {
    padding: ${props => props.$isHomePage ? '0' : 'var(--space-4) var(--space-2)'};
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <PageWrapper>
      <SimpleNav />
      <Main $isHomePage={isHomePage}>{children}</Main>
      <Footer />
    </PageWrapper>
  );
};

export default Layout; 